export default __webpack_public_path__ + "media/green_leaf.bd1b7e236741d768ef3763470816661f.jpeg";